module.exports = __webpack_public_path__ + "static/media/_GPX0665.37962429.jpeg";